  <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
/>

  <breadcrumb
    [paginas]="[
      { route: '/home', name: 'Home' },
      { route: '/relatorio-pec', name: 'Relatório POC' }
    ]"
  />

  <section class="section-saudacao" aria-labelledby="saudacao-title">
    <div class="container">
      <p>
        <b>Olá,</b> {{this.userLogado?.flPsicologo ? "Psicólogo(a)": this.atribuicoesLogin.NomePerfil }}<br />
        <b>{{this.userLogado?.flPsicologo ? this.userLogado?.nome : this.atribuicoesLogin.Nome}}</b>
      </p>
    </div>
  </section>

  <form [formGroup]="formRelatorioPEC">

  <!-- <section class="header-page-relatorio">
      <div class="container">
        <h2>Relatório - POC</h2>
        <section class="section-saudacao header-page-voltar">
          <div class="periodo">
          <p><b>Pesquisar por período:</b></p>
            <div class="periodo-input">
              <input
              type="date"
              name="dataInicial"
              min="{{minDate}}"
              max="{{maxDate}}"
              (blur)="validaAno(this.form.dataInicio)"
              formControlName="dataInicio"
              />
              &nbsp;-&nbsp;
              <input
              type="date"
              name="dataFinal"
              min="{{minDate}}"
              max="{{maxDate}}"
              (blur)="validaAno(this.form.dataFim)"
              formControlName="dataFim"
              />
            </div>
          </div>
        </section>
      </div>
    </section> -->
  </form>

  <app-filtro-padrao
  (filtroEmitter)="listeningFiltroEmitter($event)"
  [template]="3"
  [listarPOC]="true"
  [usePeriodo]="true"
  [atividadeDE]="false"
  [useAno]="false"
  [useTurno]="false"
  [textoLupa]="true"
  [escolaObrigatoria]="false"
  [autoSubmitOnInit]="false"
  [dividir2filas]="true"
    >
  </app-filtro-padrao>



  <!-- SAUDACAO USUÁRIO -->
  <!-- <section class="section-saudacao" aria-labelledby="saudacao-title">
    <div class="container">
      <p>
        <b>Olá,</b> {{this.userLogado?.flPsicologo ? "Psicólogo(a)": this.atribuicoesLogin.NomePerfil }}<br />
        <b>{{this.userLogado?.flPsicologo ? this.userLogado?.nome : this.atribuicoesLogin.Nome}}</b>
      </p>
    </div>
  </section> -->

<section class="section-info-periodo relatorio-pec-page">
  <div class="container">
    <div class="header-info">
      <h1>Informações do período</h1>
      <button class="btn-download-pdf" (click)="ExportarComoPDF()">
        <i class="bi bi-download"></i>
        <span>PDF</span>
      </button>
    </div>

    <div class="info-grid">
        <div *ngIf="infoPeriodo.polo && infoPeriodo.polo !== '-'">
          <b>Polo</b>
          <span>{{ infoPeriodo.polo }}</span>
        </div>

        <div *ngIf="infoPeriodo.diretoria && infoPeriodo.diretoria !== '-'">
          <b>URE</b>
          <span>{{ infoPeriodo.diretoria }}</span>
        </div>

        <div *ngIf="infoPeriodo.municipio && infoPeriodo.municipio !== '-'">
          <b>Município</b>
          <span>{{ infoPeriodo.municipio }}</span>
        </div>

        <div *ngIf="infoPeriodo.escola && infoPeriodo.escola !== '-'">
          <b>Escola</b>
          <span>{{ infoPeriodo.escola }}</span>
        </div>

        <div *ngIf="infoPeriodo.poc && infoPeriodo.poc !== '-'">
          <b>POC</b>
          <span>{{ infoPeriodo.poc }}</span>
        </div>

        <div *ngIf="infoPeriodo.ciclo && infoPeriodo.ciclo !== '-'">
          <b>Ciclo</b>
          <span>{{ infoPeriodo.ciclo }}</span>
        </div>

        <div *ngIf="infoPeriodo.dataInicio && infoPeriodo.dataInicio !== '-'">
          <b>Data início:</b>
          <span>{{ infoPeriodo.dataInicio | date:'dd/MM/yyyy' }}</span>
        </div>

        <div *ngIf="infoPeriodo.dataFim && infoPeriodo.dataFim !== '-'">
          <b>Data fim:</b>
          <span>{{ infoPeriodo.dataFim | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>

  </div>
</section>

<section #pdfContent id="pdf-content">
<section class="section-graficos relatorio-pec-page">
  <div class="container">
  <h3>Ações realizadas</h3>
  <div class="graficos-grid"> <!-- CARD 1: Ações de Prevenção -->
    <div class="card grafico-card"> <div class="card-body">
      <h4>Ações de prevenção</h4>
      <div class="grafico-indicador"> {{ qtyAcoesPrevencao }} ({{ porcAcoesPrevencao }}%) </div>
      <canvas #chartPrevencao baseChart
        [data]="barChartDataPrevencao"
        [options]="barChartOptionsPrevencao"
        [type]="barChartType">
        </canvas> </div> </div> <!-- CARD 2: Ações de Acolhimento -->
      <div class="card grafico-card">
        <div class="card-body">
          <h4>Ações de acolhimento</h4>
          <div class="grafico-indicador"> {{ qtyAcoesAcolhimento }} ({{ porcAcoesAcolhimento }}%)

          </div>
          <canvas #chartAcolhimento baseChart
          [data]="barChartDataAcolhimento"
          [options]="barChartOptionsAcolhimento"
          [type]="barChartType">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</section>
</section>


<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>
